let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Wq1f")).then(() => parcelRequire('8kp3a'));